import { forwardRef } from 'react';
import { BaseAppBar } from './BaseAppBar';

export const HeaderPortalSlot = forwardRef<HTMLDivElement, unknown>((_, ref) => (
    <BaseAppBar ref={ref} id="header"></BaseAppBar>
));

HeaderPortalSlot.displayName = 'HeaderPortalSlot';
